import styled from "styled-components"

import { AppearingCheckbox } from "shared/styles/common"

export const RepeatableCheckbox = styled(AppearingCheckbox)`
  margin-top: 0.5rem;
  margin-bottom: 2rem;
`
